import { useForm } from "react-hook-form";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo } from "react";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { PatrimonioMaquinaEquipModel } from "../../../../domain/models/patrimonio_maquina_equip";
import { initialPatrimonioMaquinaEquipForm, PatrimonioMaquinaEquipForm, PatrimonioMaquinaEquipSchema } from "../../../schemas/PatrimonioInspecao_cadastro/patrimonio_maquina_equip";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";

/**
 * PatrimonioMaquinaEquipChecklistModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedPatrimonioMaquinaEquip: PatrimonioMaquinaEquipModel | null,
  checklistsMaquinaEquip: DropDown[];
  onClose: () => void;
  onSubmit: (form: PatrimonioMaquinaEquipForm) => void;
};

export const PatrimonioMaquinaEquipChecklistModal = ({
  open,
  saving,
  loading,
  checklistsMaquinaEquip,
  selectedPatrimonioMaquinaEquip,
  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<PatrimonioMaquinaEquipForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: initialPatrimonioMaquinaEquipForm,
    resolver: zodResolver(PatrimonioMaquinaEquipSchema),
  });


  useEffect(() => {
    if (open) {
      if (selectedPatrimonioMaquinaEquip) {
        hookForm.setValue('idPatrimonioMaquinaEquip', selectedPatrimonioMaquinaEquip.idPatrimonioMaquinaEquip ?? 0);
        hookForm.setValue('idPatrimonioCentroCusto', selectedPatrimonioMaquinaEquip.idPatrimonioCentroCusto ?? 0);
        hookForm.setValue('descricao', selectedPatrimonioMaquinaEquip.descricao ?? '');
        hookForm.setValue('status', selectedPatrimonioMaquinaEquip.status ?? 0);
        hookForm.setValue('idChecklistMaquinaEquip', selectedPatrimonioMaquinaEquip.idChecklistMaquinaEquip ?? 0);
      } else {
        hookForm.reset(initialPatrimonioMaquinaEquipForm);
      }
    }
  }, [
    open,
    hookForm,
    selectedPatrimonioMaquinaEquip,
  ]);

  const statusOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Em aberto',
        style: {
          backgroundColor: '#f8cb00',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Finalizada',
        style: {
          backgroundColor: '#f3565d',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
    ];
  }, [
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Cadastro do tipo de máquina/equipamento'
      width="50rem"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <FormRadioGroupInput
            name='status'
            label='Status'
            options={statusOptions}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name='descricao'
            label='Descrição'
            reactHookForm={hookForm}
          />

          <DefaultFormAutocomplete
            name='idChecklistMaquinaEquip'
            label='Checklist Maquina/Equipamento'
            required={true}
            readOnly={selectedPatrimonioMaquinaEquip !== null}
            getOptionKey={x => x.id}
            getOptionLabel={x => x.title ?? ''}
            options={checklistsMaquinaEquip}
            reactHookForm={hookForm}
          />

        </>
      </FormContainer>
    </BaseFormControlledModal >
  );
}